import React from 'react'
import classes from './TriggersSection.module.scss'
import Section from '@/components/ui/Section'
import Button from '@/components/ui/Buttons/Button'
import Tag from '@/components/ui/Tag'
import { ReactComponent as TriggersIcon } from '@/assets/icons/code.svg'
import { Body, Cell, Head, HeaderCell, Row, Table } from '@/components/ui/Table'
import { useCreateNewTrigger, useOpenTrigger, useTriggers } from './TriggersSection.hooks'
import Typography from '@/components/ui/Typography'

export type TriggersSectionProps = {
  projectId: number
  routeId: number
}

export const TriggersSection = ({ projectId, routeId }: TriggersSectionProps) => {
  const triggers = useTriggers(projectId, routeId)
  const openTrigger = useOpenTrigger()
  const [createNewTrigger, isLoading] = useCreateNewTrigger(projectId, routeId)
  const isTriggersPresented = triggers && triggers.length > 0

  return (
    <Section className={classes.root}>
      <Section.Header title={'Triggers'} icon={<TriggersIcon />}>
        <Button variant={'soft'} disabled={isLoading} onClick={createNewTrigger}>
          Create new
        </Button>
      </Section.Header>
      <Section.Content isLoading={false} isCentered={!isTriggersPresented}>
        {isTriggersPresented ? (
          <Table>
            <Head>
              <HeaderCell>Name</HeaderCell>
              <HeaderCell size={'80px'} isCentered>
                Activity
              </HeaderCell>
              <HeaderCell size={'124px'} isCentered>
                Actions
              </HeaderCell>
            </Head>
            <Body maxHeight={'20vh'}>
              {triggers.map((trigger) => (
                <Row key={trigger.id}>
                  <Cell>{trigger.title}</Cell>
                  <Cell size={'80px'} isCentered>
                    {trigger.active ? <Tag color={'success'}>Active</Tag> : <Tag color={'danger'}>Inactive</Tag>}
                  </Cell>
                  <Cell size={'124px'} isCentered>
                    <Button onClick={() => openTrigger(trigger.id)} disabled={!trigger.id} color={'neutral'}>
                      Edit
                    </Button>
                  </Cell>
                </Row>
              ))}
            </Body>
          </Table>
        ) : (
          <Typography className={classes.noResults}>No triggers that use this route</Typography>
        )}
      </Section.Content>
    </Section>
  )
}
